import React, { useState } from 'react';
import VideoPlayer from 'react-video-player-extended';

export const SliderVideoPlayer = () => {
  const [isPlaying , setIsPlaying] = useState(false);
  const [volume , setVolume] = useState(0.7);

  const handlePlay = () => {
    setIsPlaying(true);
  };

  const handlePause = () => {
    setIsPlaying(false);
  };

  const handleVolume = value => {
    setVolume(value);
  };

  return (
    <VideoPlayer
      url="https://media.w3.org/2010/05/sintel/trailer.mp4"
      isPlaying={isPlaying}
      volume={volume}
      onPlay={handlePlay}
      onPause={handlePause}
      onVolume={handleVolume}
      width={'800px'}
      height={'auto'}
    />
  )
}
